var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useRef } from 'react';
export const useBeforeFirstRender = (callback) => {
    _react_refresh_temp_1();
    const isRenderedRef = useRef(false);
    if (!isRenderedRef.current) {
        callback();
        isRenderedRef.current = true;
    }
};
_react_refresh_temp_1(useBeforeFirstRender, "0Gc1h0yr3FSCypuzHhCPFLfnAvc=");
